module.exports = __webpack_public_path__ + "img/img_id_empty.a3589c77.png";